import { testDispatch } from '../utils/redux.utils';
import {instance} from "../utils/axios.utils"
import axios from 'axios';
import { getBaseURL } from 'utils/functions.utils';

const user = {
  testRequest: (body: any) => {
    let promise = new Promise((resolve, reject)=>{
      let url = "service_requests/create_service_requests"
     
      instance().post(url, body).then(res=>{
        testDispatch(res.data.data)
        resolve(res.data)
      }).catch(error=>{
        if(error.response){
          reject(error.response.data.message)
        }else{
          reject(error)
        }
      })
    })
    return promise
  },

  uploadMultiple: async (data: any) => {
    const token = localStorage.getItem("token");
    const formData = new FormData();

    data.files.forEach((file: any, index: number) => {
        formData.append('files', file);
    });
    const url = `${getBaseURL()}/upload_multiple`;
    
    try {
        // Do not set Content-Type here -- the browser must generate it itself to include the
        // multipart boundary. A manually-set 'multipart/form-data' header has no boundary, which
        // the server's multipart parser can't read, and the upload silently fails.
        const response = await axios.post(url, formData, {
            headers: {
                'Authorization': token || '',
            }
        });

        return response.data;
    } catch (error) {
        console.error("Upload error:", error);
        throw error;
    }
  },

  upload: async (data: any) => {
    const token = localStorage.getItem("token");

    const formData = new FormData();
    formData.append('file', data);

    const url = `${getBaseURL()}/upload`;

    try {
        const response = await axios.post(url, formData, {
            headers: {
                'Authorization': token || '',
            },
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        });
        return response.data;
    } catch (error) {
        console.error("Upload error:", error);
        throw error;
    }
  },

}

export default user